import React, {useEffect , useState} from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import {appGetDesigners} from "../../services/AccountServices";


// import DesignerPageDataDefault from "../../data/designers_page_data.json";

function Designers() {
  const [DesignerPageData, setDesignerPageData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    handleDesignerClick(id);

    appGetDesigners().then((res)=>{
      res = JSON.parse(res?.data);
      if(res.status){
        var DesignerPageDataResponse = res?.data ;
        setDesignerPageData(DesignerPageDataResponse);
      }
    });
  }, [id]);

  const handleDesignerClick = (d) => {
    if (d) {
      //   document.getElementById(d?.toLowerCase()).scrollIntoView(true);
      var element = document.getElementById(d?.toLowerCase());
      if (element) {
        var headerOffset = 50;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "instant",
        });
      }
    }
  };

  return (
    <>
      {/* Header */}
      <Header
        mobileHeaderOptions={{
          menuIcon: true,
          wishlistIcon: true,
          darveysLargeTextIcon: true,
          searchIcon: true,
          shoppingBagIcon: true,
          backButtonIcon: false,
          pageHeadingShow: false,
          pageHeadingText: "Designers",
          darveysSmallIcon: false,
          userAccountIcon: false,
        }}
      />

      <div className="clearfix"></div>

      {/* <!-- DESIGNERS MAIN STARTS --> */}
      <section className="designer-main spacer-xl">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="main-heading-center">
                <h3>Shop By Designers</h3>
              </div>
            </div>
            <div className="col-12">
              <div className="alphabets">
                <ul className="pl-0 mb-0">
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("#")}
                    >
                      #
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("a")}
                    >
                      A
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("b")}
                    >
                      B
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("c")}
                    >
                      C
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("d")}
                    >
                      D
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("e")}
                    >
                      E
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("f")}
                    >
                      F
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("g")}
                    >
                      G
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("h")}
                    >
                      H
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("i")}
                    >
                      I
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("j")}
                    >
                      J
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("k")}
                    >
                      K
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("l")}
                    >
                      L
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("m")}
                    >
                      M
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("n")}
                    >
                      N
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("o")}
                    >
                      O
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("p")}
                    >
                      P
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("q")}
                    >
                      Q
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("s")}
                    >
                      S
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("t")}
                    >
                      T
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("u")}
                    >
                      U
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("v")}
                    >
                      V
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("w")}
                    >
                      W
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("x")}
                    >
                      X
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("y")}
                    >
                      Y
                    </span>
                  </li>
                  <li>
                    <span
                      className="cursor-pointer"
                      onClick={(e) => handleDesignerClick("z")}
                    >
                      Z
                    </span>
                  </li>
                </ul>
              </div>

              {DesignerPageData && DesignerPageData?.map((designer) => {
                return (
                  <div
                    className="designer-by-alpha"
                    id={designer.id}
                    key={designer.id}
                  >
                    <div className="main-alpha">
                      {designer?.id?.toUpperCase()}
                    </div>
                    <ul className="pl-0 mb-0">
                      {designer?.data?.map((dName, indx) => {
                        return (
                          <li key={"dli" + indx}>
                            <Link to={`/catalog/${dName?.url_path}`}>
                              {dName?.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- DESIGNERS MAIN ENDS --> */}
    </>
  );
}

export default Designers;
  